import { useRouter } from 'next/router';
import { useRef, useState } from 'react';
import ChevronLeft from '../../../shared/assets/icons/redesign/chevron-left.svg';

import './CategoryHeader.scss';
import { useDimensions } from '../../../helpers/image';

export default function CategoryHeader({ imageUrl, title, description }) {
  const router = useRouter();
  const desktopImg = useRef();
  const desktopImgDimensions = useDimensions(desktopImg);
  const [imgLoaded, setImgLoaded] = useState(false);

  const desktopImgSrc =
    imageUrl &&
    imageUrl
      .replace('/w/', `/${desktopImgDimensions?.width * 2}/`)
      .replace('/h/', `/${desktopImgDimensions?.height * 2}/`);

  return (
    <div className="categoryHeader">
      {imageUrl && (
        <>
          <div className="categoryHeader-img-mobile _mobile">
            <img
              src={imageUrl.replace('/w/', `/1700/`).replace('/h/', `/450/`)}
              alt="category-image"
            />
          </div>

          <div
            className="categoryHeader-img-desktop-wrap _desktop"
            ref={desktopImg}
          >
            {desktopImgDimensions && imgLoaded && (
              <div
                className="categoryHeader-img-desktop"
                style={{
                  background: `url("${desktopImgSrc}") no-repeat center/cover`
                }}
              >
                <div className="categoryHeader-img-desktop-overlay">
                  <div className="categoryHeader-data">
                    <div>
                      <p className="categoryHeader-title">{title}</p>
                      <p className="categoryHeader-description">
                        {description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}

      <div className="categoryHeader-data _mobile">
        <div>
          <p className="categoryHeader-title">{title}</p>
          <p className="categoryHeader-description">{description}</p>
        </div>
      </div>

      <a
        className="categoryHeader-back-btn cursor-pointer _mobile"
        onClick={() => router.back()}
      >
        <ChevronLeft className="categoryHeader-back-btn-arrow" />
        Terug
      </a>

      <img hidden src={desktopImgSrc} onLoad={() => setImgLoaded(true)} />
    </div>
  );
}
